import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './authContext';

const ProtectedRoute = ({ element: Component, module, operations, ...rest }) => {
  const { isAuthenticated, hasPermission, loading, user } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div>Loading...</div>; // Show loading while user data is being fetched
  }
  if (isAuthenticated() && user?.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" state={{ from: location }} />;
  }
  if (!isAuthenticated() || !hasPermission(module, operations)) {
    // Redirect to the unauthorized page or login page
    return <Navigate to="/unauthorized" state={{ from: location }} />;
  }

  return Component;
};

export default ProtectedRoute;
